import React from "react";
import { TwoToneGeneralAutofill } from '@hose/eui-icons';
export var AITextIcon = function () {
    return (React.createElement("div", { style: {
            display: 'inline-flex',
            whiteSpace: 'nowrap',
            height: '20px',
            padding: '1px 4px',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '4px',
            background: 'linear-gradient(270deg, #D7CAFF -12.77%, #D7CAFF -12.75%, #E2FCFF 100%), linear-gradient(90deg, #FF8A00 0%, #FF3D00 100%)',
            color: '#4E77FE',
            font: 'var(--eui-font-note-b2)',
        } },
        React.createElement(TwoToneGeneralAutofill, { fontSize: 16 }),
        React.createElement("span", null, "AI\u586B\u5199")));
};
export default AITextIcon;
